<div class="fields-wrapper" [formGroup]="platformCostForm">
  <div class="field" [class.selected]="isOptionSelected(platformCostType.Percentage)">
    <div class="ui radio checkbox">
      <input
        type="radio"
        [id]="platformCostType.Percentage + formControlName"
        [value]="platformCostType.Percentage"
        formControlName="costType"
      />
      <label [for]="platformCostType.Percentage + formControlName" data-lokalise data-key="txt_percentage"></label>
    </div>
    <div class="cost-value">
      <span>+</span>
      <input
        type="text"
        formControlName="percentage"
        mask="percent.2"
        [dropSpecialCharacters]="false"
        (ngModelChange)="onPercentageChange($event)"
      />
      <span>%</span>
    </div>
  </div>
  <div class="field" [class.selected]="isOptionSelected(platformCostType.FixedAmount)">
    <div class="ui radio checkbox">
      <input
        type="radio"
        [id]="platformCostType.FixedAmount + formControlName"
        [value]="platformCostType.FixedAmount"
        formControlName="costType"
      />
      <label [for]="platformCostType.FixedAmount + formControlName" data-lokalise data-key="txt_fixed_amount"></label>
    </div>
    <div class="cost-value">
      <span>+</span>
      <input
        type="text"
        formControlName="amount"
        mask="separator.2"
        [allowNegativeNumbers]="false"
        (ngModelChange)="onAmountChange($event)"
      />
      <span>{{ 0 | currencySymbol: currency }}</span>
    </div>
  </div>
  <div class="field" [class.selected]="isOptionSelected(platformCostType.Mixed)">
    <div class="ui radio checkbox">
      <input
        type="radio"
        [id]="platformCostType.Mixed + formControlName"
        [value]="platformCostType.Mixed"
        formControlName="costType"
      />
      <label [for]="platformCostType.Mixed + formControlName">
        {{ 'txt_percentage' | translate }} + {{ 'txt_fixed_amount' | translate }}
      </label>
    </div>
    <div class="cost-values">
      <div class="cost-value">
        <span>+</span>
        <input
          type="text"
          formControlName="mixedPercentage"
          mask="percent.2"
          [dropSpecialCharacters]="false"
          (ngModelChange)="onMixedPercentageChange($event)"
        />
        <span>%</span>
      </div>
      <div class="cost-value">
        <span>+</span>
        <input
          type="text"
          formControlName="mixedAmount"
          mask="separator.2"
          [allowNegativeNumbers]="false"
          (ngModelChange)="onMixedAmountChange($event)"
        />
        <span>{{ 0 | currencySymbol: currency }}</span>
      </div>
    </div>
  </div>
</div>
